import { render, staticRenderFns } from "./FireComplaintFiledQuestion.vue?vue&type=template&id=155301db&scoped=true"
import script from "./FireComplaintFiledQuestion.vue?vue&type=script&lang=ts"
export * from "./FireComplaintFiledQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155301db",
  null
  
)

export default component.exports